import { FC } from 'react'
import { Skeleton, SxProps, Theme } from '@mui/material'

/* Components */
import { SSMCardSkeleton, SSMCardSkeletonWrapper } from '../../../../../security-stack-map/components/ssmCard.styles'

interface Props {
  width?: number | string
  height?: number | string
  variant?: 'rectangular' | 'circular'
  sx?: SxProps<Theme>
}

/**
 * Shared "wave" loading skeleton used across the dashboard loading state so every
 * section animates consistently (matching the Insights widget). Reuses the SSM card
 * skeleton wrappers that already define the wave gradient styling.
 */
const WaveSkeleton: FC<Props> = ({ width = '100%', height = '100%', variant = 'rectangular', sx }) => (
  <SSMCardSkeletonWrapper>
    <SSMCardSkeleton>
      <Skeleton
        variant={variant}
        component="div"
        animation="wave"
        width={width}
        height={height}
        className="card-skeleton-inner"
        sx={sx}
      />
    </SSMCardSkeleton>
  </SSMCardSkeletonWrapper>
)

export default WaveSkeleton